import * as TP from '../types';

import { gql } from '@apollo/client';
export type CustomerPickerItemFragment = (
  { readonly __typename?: 'Customer' }
  & Pick<TP.Customer, 'code' | 'id' | 'name' | 'currencyId'>
  & { readonly mainAddress?: TP.Maybe<(
    { readonly __typename?: 'Address' }
    & Pick<TP.Address, 'id' | 'city' | 'state'>
  )>, readonly customerStatusType?: TP.Maybe<(
    { readonly __typename?: 'KeyValue' }
    & Pick<TP.KeyValue, 'id' | 'name'>
  )> }
);

export const CustomerPickerItemFragmentDoc = gql`
    fragment CustomerPickerItem on Customer {
  code
  id
  name
  mainAddress {
    id
    city
    state
  }
  customerStatusType {
    id
    name
  }
  currencyId
}
    `;